import MetaRobots from './MetaRobots';

export default MetaRobots;
